module.exports = __webpack_public_path__ + "img/dirk_lehmann.427694fa.jpg";